"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectClearButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../../i18n/i18n");
var _useTheme = require("../../../../theme/utils/useTheme");
var _useHovered = require("../../../../util/useHovered");
var _ActionButton = require("./ActionButton");
const SelectClearButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    ...props
  } = _ref;
  const {
    i18n
  } = (0, _i18n.useI18n)();
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    isHovered,
    ...useHoveredHandlers
  } = (0, _useHovered.useHovered)();
  const activeAndHoveredHandlers = (0, _lodestarUtils.useActive)(useHoveredHandlers);
  return /*#__PURE__*/_react.default.createElement(_ActionButton.ActionButton, (0, _extends2.default)({}, activeAndHoveredHandlers, {
    themeMode: themeMode,
    isHovered: isHovered,
    ref: ref,
    "aria-label": i18n._( /*i18n*/{
      comment: "This deselects all the selected values",
      id: "Clear selection"
    }),
    onClick: e => {
      if (props.isMultiSelect) {
        props.closeMenu?.();
        // It's important that we call these two functions in this order.
        // Why? IDK.
        props.setActiveIndex?.(-1);
        props.clearSelectedItems?.();
      } else {
        props.clearSelection(null);
      }
      // For some reason, focusing this in the current tick causes the
      // setSelectedItems to do nothing.
      requestAnimationFrame(props.refocusTargetElement);
      // Don't let the container handle this.
      e.stopPropagation();
      props.resetFiltering?.("click-select-clear-button");
    }
  }), (() => {
    if (themeMode === "ursa-light") {
      return /*#__PURE__*/_react.default.createElement(_ursaIcons.CloseIcon, {
        size: 16
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_lodestarIcons.CloseIcon, null);
    }
  })());
});
exports.SelectClearButton = SelectClearButton;
SelectClearButton.displayName = "SelectClearButton";
//# sourceMappingURL=SelectClearButton.js.map